import { classNames } from "primereact/utils";
import { Theme } from "../../../../common/types";
import { IconBetterspace } from "../Icons";

interface BetterspaceWordmarkProps {
    theme: Theme;
    iconClassName?: string;
    textClassName: string;
}

const BetterspaceWordmark = (props: BetterspaceWordmarkProps) => {
    const { theme, iconClassName = "[&>svg]:h-8.5", textClassName } = props;

    return (
        <>
            <span className={classNames("[&>svg]:w-auto", iconClassName)}>
                <IconBetterspace type={theme} />
            </span>
            <span
                className={classNames(
                    "font-headline font-semibold",
                    textClassName
                )}
            >
                Betterspace
            </span>
        </>
    );
};

export default BetterspaceWordmark;
